import type { FragmentOf } from "@opensea/graphql"
import { readFragment } from "@opensea/graphql"
import { Table } from "@opensea/ui-kit"
import { CreateCollectionOfferFlowTableFragment } from "./CreateCollectionOfferFlowTable.fragment"
import {
  CreateCollectionOfferFlowTableHeader,
  CreateCollectionOfferFlowTableHeaderSkeleton,
} from "./CreateCollectionOfferFlowTableHeader"
import {
  CreateCollectionOfferFlowTableRow,
  CreateCollectionOfferFlowTableRowSkeleton,
} from "./CreateCollectionOfferFlowTableRow"

type Props = {
  collection: FragmentOf<typeof CreateCollectionOfferFlowTableFragment>
  isReview: boolean
}

export const CreateCollectionOfferFlowTable = ({
  collection: collectionKey,
  isReview,
}: Props) => {
  const collection = readFragment(
    CreateCollectionOfferFlowTableFragment,
    collectionKey,
  )

  return (
    <>
      <CreateCollectionOfferFlowTableHeader />
      <Table
        className="shrink-0"
        context={{ isReview }}
        itemKey={collection => collection?.slug}
        items={[collection]}
        renderRow={CreateCollectionOfferFlowTableRow}
        size="md"
      />
    </>
  )
}

export const CreateCollectionOfferFlowTableSkeleton = () => {
  return (
    <>
      <CreateCollectionOfferFlowTableHeaderSkeleton />
      <Table
        className="shrink-0"
        itemKey={(_, index) => index}
        items={[0]}
        renderRow={CreateCollectionOfferFlowTableRowSkeleton}
        size="md"
      />
    </>
  )
}
